/**
 * Default: Components / Custom > Calculator
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Tobias Garz
 */

import { RangeSlider } from '../../shared/form/range/index.js';

// ---------------------------------------------------------------------------------------------------------------------
// Maps
// ---------------------------------------------------------------------------------------------------------------------

const ELECTRICITY_MAP = [
	{ value: 1, output: 1500 },
	{ value: 2, output: 2500 },
	{ value: 3, output: 3000 },
	{ value: 4, output: 4000 },
	{ value: 5, output: 5000 },
	{ value: 6, output: 7000 },
];

const GAS_MAP = [
	{ value: 1, label: 30,  output: 4000  },
	{ value: 2, label: 70,  output: 9000  },
	{ value: 3, label: 120, output: 15000 },
	{ value: 4, label: 150, output: 20000 },
	{ value: 5, label: 200, output: 26000 },
];

// ---------------------------------------------------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------------------------------------------------

const index = () => {
	const electricityRangeEl = document.querySelector('#consumption-electricity-range');
	if (electricityRangeEl) {
		new RangeSlider(electricityRangeEl, {
			min  : 1,
			max  : 6,
			step : 1,
			value: 1,
			map  : ELECTRICITY_MAP,
			onRender: ({ sliderValue, rangeEl, iconEl }) => {
				if (iconEl) {
					iconEl.className = sliderValue >= 2 ? 'fa-regular fa-user-group' : 'fa-regular fa-user';
				}
				rangeEl.setAttribute(
					'aria-valuetext',
					sliderValue === 1 ? '1 Person' : `${sliderValue} Personen`
				);
			},
		}).init();
	}

	const gasRangeEl = document.querySelector('#consumption-gas-range');
	if (gasRangeEl) {
		new RangeSlider(gasRangeEl, {
			min  : 1,
			max  : 5,
			step : 1,
			value: 1,
			map  : GAS_MAP,
			onRender: ({ entry, rangeEl, iconEl }) => {
				if (iconEl) {
					iconEl.className = 'fa-regular fa-house';
				}
				rangeEl.setAttribute(
					'aria-valuetext',
					`${entry?.label ?? ''} Quadratmeter`
				);
			},
		}).init();
	}
};

export default index;
